export default {
  AudioButton: {
    play: '播放试题',
  },
  ezinterview_video_help: {
    section1: [
      '1、浏览器检测失败。',
      '视频面试需要使用chrome 60版本及以上的浏览器，请根据相关版本下载浏览器：',
      'window版本下载',
      'mac版本下载',
      'linux版本下载',
      'ios版本下载',
      'android版本下载',
      '目前不支持其他浏览器。',
    ],
    section2: [
      '2、摄像头检测失败。',
      '(1)、请确保设备带有摄像头或外接摄像头设备，并安装了驱动程序。',
      '(2)、请关闭电脑杀毒软件、代理VPN等，确保网速在100kb/s以上。',
      '(3)、允许浏览器启用摄像头权限（请点击允许）。',
      '(4)、检查浏览器地址栏右侧是否对摄像头和麦克风设置禁用。',
      '(5)、安全设置中，请将网站摄像头，麦克风，声音权限设置为允许。',
    ],
    section3: [
      '3、麦克风检测失败。',
      '(1)、请确保设备带有麦克风或外接麦克风设备并安装了驱动程序，设备未调至静音模式。',
      '(2)、请关闭电脑杀毒软件、代理VPN等，确保网速在100kb/s以上。',
      '(3)、允许浏览器启用了麦克风权限（请点击允许）。',
      '(4)、检查浏览器地址栏右侧是否对摄像头和麦克风设置禁用。',
      '(5)、安全设置中，请将网站摄像头，麦克风，声音权限设置为允许。',
    ],
    section4: [
      '4、声音检测失败。',
      '(1)、请确保电脑带有扬声器或耳机，并安装相关驱动，设备未调至静音模式。',
      '(2)、请关闭电脑杀毒软件、代理VPN等，确保网速在100kb/s以上。',
      '(3)、允许浏览器启用了摄像头、麦克风权限（请点击允许）。',
      '(4)、检查浏览器地址栏右侧是否对摄像头和麦克风设置禁用。',
      '(5)、安全设置中，请将网站摄像头，麦克风，声音权限设置为允许。',
    ],
    tips: '去请去应用商店搜索最新版chrome浏览器下载',
  },
  grading_level: {
    title: '评分标准',
  },
  history_score: {
    absent: '候选人弃考，无成绩',
    exempt: '候选人免测，不计算成绩',
    fraud: '候选人舞弊，无成绩',
  },
  interviewer_navbar: {
    time: '北京时间',
  },
  language_select: {
    changeLanguage: '更换系统语言',
  },
  loginout_btn: {
    logout: '退出登录',
    signOutCofirm: '确定退出面试评分系统？',
    signOutCancel: '取消退出',
  },
  password_change: {
    menu: '修改密码',
    title: '修改密码',
    close: '关闭',
    oldPassword: '原密码',
    oldPasswordPlaceholder: '请输入原密码',
    newPassword: '新密码',
    newPasswordPlaceholder: '请输入新密码',
    confirmPassword: '确认新密码',
    confirmPasswordPlaceholder: '请再次输入新密码',
    toggleVisibility: '显示或隐藏密码',
    cancel: '取消',
    confirm: '确认修改',
    success: '密码修改成功',
    failed: '密码修改失败',
    validation: {
      required: '请完整填写密码信息',
      tooShort: '新密码长度不能少于6位',
      tooLong: '新密码长度不能超过100位',
      mismatch: '两次输入的新密码不一致',
      unchanged: '新密码不能与原密码相同',
    },
  },
  navbar: {
    placeholder: '名称',
  },
  operate_and_time: {
    time: '北京时间',
  },
  operate_mobile: {
    title: '设备检测',
  },
  pre_detection: {
    title: '设备检测',
    browser: '浏览器',
    help: '帮助？',
    video: '摄像头',
    audio: '麦克风',
    broadWidth: '视频带宽',
    delay: '延迟',
    confirm: '确定',
    helpTitle: '易面 使用帮助',
    close: '关闭',
    btnName1: ['点击检测麦克风', '停止录音...'],
    btnName2: ['播放声音', '停止播放'],
    audioDevice: '麦克风设备',
    videoDevice: '摄像头设备',
    audioMsg: '请先停止播放',
    audioConfirmMsg: '检测麦克风期间，系统将录制一段您的声音，您可以在录制好后点击播放声音按钮来确定麦克风是否有效',
    recordMsg1: '请先点击检测麦克风',
    recordMsg2: '请先停止录音',
    errorTips: '请尝试通过浏览器打开此页面以访问摄像头设备',
    back: '返回',
    precheck: '面试前检查',
    recheck: '重新检测',
    speaker: '扬声器',
    network: '网络',
    playSpeaker: '播放测试音',
    heardSpeaker: '我听到了',
    notHeardSpeaker: '我没听到',
    readyItems: '已通过项目',
    version: '版本',
    secureContext: '安全环境',
    onlineStatus: '联网状态',
    yes: '是',
    no: '否',
    online: '在线',
    offline: '离线',
    unknown: '未知',
    idle: '待检测',
    checking: '检测中',
    passed: '正常',
    warning: '需注意',
    failed: '异常',
    cameraPlaceholder: '请选择摄像头',
    microphonePlaceholder: '请选择麦克风',
    cameraWaiting: '等待摄像头检测',
    cameraStarting: '正在开启摄像头...',
    cameraReady: '摄像头画面正常',
    microphoneWaiting: '等待麦克风检测',
    microphoneStarting: '正在开启麦克风...',
    microphoneReady: '麦克风输入正常',
    microphoneLevel: '麦克风音量',
    microphoneTip: '请对着麦克风说话，音量条有波动即表示输入正常。',
    speakerWaiting: '请点击播放测试扬声器提示音',
    speakerPlaying: '正在播放测试提示音...',
    speakerConfirm: '如果听到测试音，请点击“我听到了”',
    speakerReady: '扬声器播放正常',
    speakerNotHeard: '未听到测试提示音，请检查系统音量、标签页静音状态和音频输出设备',
    speakerFailed: '测试提示音播放失败，请检查浏览器音频播放权限和系统音量',
    networkWaiting: '等待网络检测',
    networkChecking: '正在检测网络...',
    networkReady: '网络连接正常',
    networkSlow: '网络延迟偏高，面试时可能出现卡顿',
    networkOffline: '当前浏览器处于离线状态',
    networkLimited: '已联网，但无法完成延迟检测',
    browserWaiting: '等待浏览器检测',
    browserReady: '当前浏览器支持摄像头和麦克风检测',
    browserChromeRequired: 'Chrome 浏览器版本过低，请升级至 {version} 或以上版本',
    browserChromeLatest: '当前不是 Chrome 浏览器，请使用最新版 Chrome 打开页面',
    browserUnsupported: '当前浏览器不支持摄像头或麦克风检测',
    browserInsecure: '请使用 HTTPS 或 localhost 打开页面后再检测',
    permissionDenied: '无法获取设备权限，请在浏览器中允许访问摄像头和麦克风',
    deviceNotFound: '未找到可用设备，请确认设备已连接',
    deviceBusy: '设备可能被其他程序占用，请关闭占用程序后重试',
    deviceFailed: '设备开启失败，请检查浏览器权限和系统设置',
  },
  table: {
    name: '姓名',
    number: '编号',
    gender: '性别',
    status: '状态',
    callStatus: '叫号状态',
    callStatusText: {
      undo: '未叫号',
      calling: '已叫号',
    },
    score: '我的评分',
    average: '平均成绩',
    class: '等级',
    checkIn: '已签到',
    signIn: '签到',
    preview: '图片预览',
    noMsg: '暂无候选人',
    actions: '操作',
    aboveAverage: '高于平均分',
    belowAverage: '低于平均分',
    statusText: {
      unsubmitted: '进行中',
      waiting: '未开始',
      interviewing: '进行中',
      complete: '已结束',
      processing: '已结束',
      confirmed: '已结束',
      unconfirmed: '已结束',
    },
    button: {
      unsubmitted: '评分',
      waiting: '评分',
      interviewing: '评分',
      complete: '修改成绩',
      processing: '查看',
      confirmed: '修改成绩',
      unconfirmed: '修改成绩',
      view: '查看',
    },
    genderOption: {
      男: '男',
      女: '女',
    },
    scoreTag: {
      unconfirmed: '未通过',
      confirmed: '已通过',
      processing: '审核中',
    },
  },
  video_interview: {
    tipMsg: '连接中，请稍后...',
    failMsg: '连接失败，请检查摄像和音频设备',
    retry: '点击重试',
    timeMsg: '分钟后将结束视频',
    videoMsg: '您的视频面试窗口在另外一台设备或标签页被打开',
    detectionMsg: '请尝试通过浏览器打开此页面以访问摄像头设备',
  },
  video_table: {
    scoreStatus: '评分状态',
    arrangement: '安排名称',
    time: '面试时间',
    name: '姓名',
    gender: '性别',
    score: '得分',
    average: '平均成绩',
    class: '等级',
    login: '已登录',
    online: '在线',
    offline: '离线',
    view: '查看',
    noMsg: '暂无候选人',
    status: {
      waiting: '未开始',
      interviewing: '进行中',
      complete: '已结束',
      default: '出错了',
    },
    genderOption: {
      男: '男',
      女: '女',
    },
  },
  IframePopup: {
    title: '考生试卷',
  },
  fontSize: {
    label: '字号',
    size: {
      normal: '正常',
      large: '大',
      xlarge: '最大',
    },
  },
  FileViewer: {
    unknownFile: '未知文件',
    downloadFile: '下载文件',
    fileType: {
      doc: 'Word 文档',
      xls: 'Excel 表格',
      ppt: 'PowerPoint 演示文稿',
      zip: '压缩文件',
      audio: '音频文件',
      video: '视频文件',
      fallback: '{ext} 文件',
    },
  },
};
